import React, {useState} from 'react';

import beverageData from './data/allBeverages.json';

import './BeverageTable.css';

const BeverageTable = () => {
    const [sortConfig, setSortConfig] = useState({key: 'name', direction: 'ascending'})
    const sortedData = [...beverageData].sort((a, b) => {
        if (sortConfig !== null) {
            const {key, direction} = sortConfig;
            if(a[key] < b[key]) {
                return direction === 'ascending' ? -1 : 1;
            }
            if(a[key] > b[key]) {
                return direction === 'ascending' ? 1 : -1;
            }
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({key, direction});
    };

    return (
        <div className="BeverageTable">
            <table>
                <thead>
                    <tr>
                        <th onClick={() => handleSort('name')} style={{cursor: 'pointer'}}>
                            Name {sortConfig.key === 'name' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
                        </th>
                        <th onClick={() => handleSort('producer')} style={{cursor: 'pointer'}}>
                            Producer {sortConfig.key === 'producer' && (sortConfig.direction === 'ascending' ? '▲' : '▼')}
                        </th>
                    </tr>
                </thead>
                {
                    sortedData.map((beverage, index) => {
                        return (
                            <tr key={index}>
                                <td>{beverage.name}</td>
                                <td>{beverage.producer}</td>
                            </tr>
                        )
                    })
                }
            </table>
        </div>
    )
}

export default BeverageTable;